import { useEffect, useRef, useState } from 'react';

export const useScrolledToBottom = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [hasScroll, setHasScroll] = useState(false);
  const [isScrolledFromTop, setIsScrolledFromTop] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const checkScroll = () => {
      const isScrollable = el.scrollHeight > el.clientHeight;
      const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
      setHasScroll(isScrollable && !isAtBottom);
      setIsScrolledFromTop(el.scrollTop > 1);
    };

    checkScroll();

    const resizeObserver = new ResizeObserver(checkScroll);
    resizeObserver.observe(el);
    el.addEventListener('scroll', checkScroll);

    return () => {
      resizeObserver.disconnect();
      el.removeEventListener('scroll', checkScroll);
    };
  }, []);

  return { ref, hasScroll, isScrolledFromTop };
};
